var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "crumbs-totals" },
        [_vm._t("breadcrumbs"), _vm._v(" "), _vm._t("totals")],
        2
      ),
      _vm._v(" "),
      _vm._t("groupBy"),
      _vm._v(" "),
      _vm._t("pagination"),
      _vm._v(" "),
      _c("table", { staticClass: "docs-table" }, [
        _c("thead", [
          _c(
            "tr",
            { staticClass: "rounded" },
            [
              _c("th", [
                _c(
                  "a",
                  {
                    class: ["sort", { disabled: _vm.disabled }],
                    attrs: { role: "button", title: "Sort by document title" },
                    on: {
                      click: function ($event) {
                        return _vm.changeSort(
                          "field:" + _vm.results.summary.docFields.titleField
                        )
                      },
                    },
                  },
                  [_vm._v("Document")]
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.shownMetadataCols, function (meta) {
                return _c("th", { key: meta.id }, [
                  _c(
                    "a",
                    {
                      class: ["sort", { disabled: _vm.disabled }],
                      attrs: {
                        role: "button",
                        title:
                          "Sort by " +
                          (_vm.specialMetaDisplayNames[meta.id] ||
                            meta.displayName),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeSort("field:" + meta.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(
                            _vm.specialMetaDisplayNames[meta.id] ||
                              meta.displayName
                          ) +
                          " "
                      ),
                      _c("Debug", [_vm._v("(id: " + _vm._s(meta.id) + ")")]),
                    ],
                    1
                  ),
                ])
              }),
              _vm._v(" "),
              _vm.hasHits
                ? _c("th", [
                    _c(
                      "a",
                      {
                        class: ["sort", { disabled: _vm.disabled }],
                        attrs: {
                          role: "button",
                          title: "Sort by number of hits",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeSort("numhits")
                          },
                        },
                      },
                      [_vm._v("Hits")]
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.rows, function (rowData, index) {
              return [
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          show: _vm.pinnedTooltip === index,
                          content: "Document id: " + rowData.docPid,
                          trigger:
                            _vm.pinnedTooltip === index ? "manual" : "hover",
                          targetClasses:
                            _vm.pinnedTooltip === index ? "pinned" : undefined,
                          hideOnTargetClick: false,
                          autoHide: false,
                        },
                        expression:
                          "{\n\t\t\t\t\t\tshow: pinnedTooltip === index,\n\t\t\t\t\t\tcontent: `Document id: ${rowData.docPid}`,\n\t\t\t\t\t\ttrigger: pinnedTooltip === index ? 'manual' : 'hover',\n\t\t\t\t\t\ttargetClasses: pinnedTooltip === index ? 'pinned' : undefined,\n\t\t\t\t\t\thideOnTargetClick: false,\n\t\t\t\t\t\tautoHide: false,\n\t\t\t\t\t}",
                      },
                    ],
                    key: index,
                    staticClass: "rounded",
                    on: {
                      click: function ($event) {
                        _vm.pinnedTooltip =
                          _vm.pinnedTooltip === index ? null : index
                      },
                    },
                  },
                  [
                    _c("td", [
                      _c(
                        "a",
                        {
                          staticClass: "doctitle",
                          attrs: { target: "_blank", href: rowData.href },
                        },
                        [_vm._v(_vm._s(rowData.summary))]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.shownMetadataCols, function (meta) {
                      return _c("td", { key: meta.id }, [
                        _vm._v(
                          _vm._s(
                            (rowData.doc.docInfo[meta.id] || []).join(", ")
                          )
                        ),
                      ])
                    }),
                    _vm._v(" "),
                    _vm.hasHits
                      ? _c("td", [_vm._v(_vm._s(rowData.hits))])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.showDocumentHits
                  ? _c(
                      "tr",
                      { key: index + "_hits", staticClass: "hit-details" },
                      [
                        _c(
                          "td",
                          { attrs: { colspan: "600" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "clearfix",
                                staticStyle: {
                                  "border-bottom": "1px solid #ddd",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-5 text-right" },
                                  [
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.leftLabel)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._m(0, true),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-xs-5" }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.rightLabel)),
                                  ]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(rowData.snippets, function (conc, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "clearfix concordance",
                                  attrs: { dir: _vm.textDirection },
                                },
                                [
                                  _vm.concordanceAsHtml
                                    ? [
                                        _c("div", {
                                          staticClass: "col-xs-5 text-right",
                                          domProps: {
                                            innerHTML: _vm._s(conc.left),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-xs-2 text-center",
                                          },
                                          [
                                            _c("strong", {
                                              domProps: {
                                                innerHTML: _vm._s(conc.hit),
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "col-xs-5",
                                          domProps: {
                                            innerHTML: _vm._s(conc.right),
                                          },
                                        }),
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-xs-5 text-right",
                                          },
                                          [_vm._v("… " + _vm._s(conc.left))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "col-xs-2 text-center",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(_vm._s(conc.hit) + " "),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-xs-5" }, [
                                          _vm._v(_vm._s(conc.right) + " …"),
                                        ]),
                                      ],
                                ],
                                2
                              )
                            }),
                            _vm._v(" "),
                            _vm.hasHits &&
                            rowData.hits > rowData.snippets.length
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-muted clearfix col-xs-12",
                                  },
                                  [
                                    _vm._v(
                                      "...(" +
                                        _vm._s(
                                          rowData.hits - rowData.snippets.length
                                        ) +
                                        " more hidden hits)"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _vm._t("sort"),
          _vm._v(" "),
          _vm.resultsHaveHits
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.showDocumentHits = !_vm.showDocumentHits
                    },
                  },
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.showDocumentHits ? "Hide Hits" : "Show Hits") +
                      "\n\t\t"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._t("export"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-xs-2 text-center", staticStyle: { padding: "0" } },
      [_c("strong", [_vm._v("Hit")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }